import { render, staticRenderFns } from "./ClipInspector.vue?vue&type=template&id=3e945f30&"
import script from "./ClipInspector.vue?vue&type=script&lang=js&"
export * from "./ClipInspector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports